"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NetSuiteApiType = exports.NetSuiteRequestVerb = void 0;
/* @TranslateToPython */
var NetSuiteRequestVerb;
(function (NetSuiteRequestVerb) {
    NetSuiteRequestVerb["GET"] = "GET";
    NetSuiteRequestVerb["POST"] = "POST";
})(NetSuiteRequestVerb || (exports.NetSuiteRequestVerb = NetSuiteRequestVerb = {}));
/* @TranslateToPython */
var NetSuiteApiType;
(function (NetSuiteApiType) {
    // https://system.netsuite.com/help/helpcenter/en_US/APIs/REST_API_Browser/record/v1/2025.1/index.html#tag-journalEntry
    NetSuiteApiType["GET_JOURNAL_ENTRY"] = "GET_JOURNAL_ENTRY";
    NetSuiteApiType["GET_ADVANCED_INTERCOMPANY_JOURNAL_ENTRY"] = "GET_ADVANCED_INTERCOMPANY_JOURNAL_ENTRY";
    NetSuiteApiType["CREATE_JOURNAL_ENTRY"] = "CREATE_JOURNAL_ENTRY";
    NetSuiteApiType["CREATE_ADVANCED_INTERCOMPANY_JOURNAL_ENTRY"] = "CREATE_ADVANCED_INTERCOMPANY_JOURNAL_ENTRY";
})(NetSuiteApiType || (exports.NetSuiteApiType = NetSuiteApiType = {}));
